export const getAccessToken = () => localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken');
export const deleteSessionData = () => sessionStorage.clear();
export const storeAccessToken = (accessToken) => sessionStorage.setItem('accessToken', accessToken);

// store token in case of remember me is checked
export const storeToken = (accessToken) => localStorage.setItem('accessToken', accessToken);
export const deleteToken = () => localStorage.clear();

// Path: src/utils/auth-token-utils/jwt.js
export const storeUserInfo = (userData) => localStorage.setItem('user', JSON.stringify(userData));
export const getUserInfo = () => JSON.parse(localStorage.getItem('user')) || {};
